import { Dispatch } from 'react';
import { ERROR_CODE } from 'src/constants';
import { IContent, IContentDetail, IStoreState } from 'src/interface';
import { Logger } from 'src/utils';
import { fetchWithTimeout } from 'src/utils/http';
import { getContentSelector } from 'src/selectors/content';
import Notify from 'src/components/notify';
import { _openContent, closeContent, putContent } from './dispatchActions';

export const openContent =
    (content: IContent) =>
    (dispatch: Dispatch<any>, getState: () => IStoreState) => {
        const { contentId } = content;
        const state = getState();
        const currentContent = getContentSelector(contentId)(state);

        dispatch(_openContent({ id: contentId, contentId } as any));

        fetchWithTimeout(
            '/content/get/detail',
            { id: contentId },
            {},
            3000,
            false,
        )
            .then((resp: any) => {
                if (resp && resp.data) {
                    const data: IContentDetail = resp.data;
                    if (!data.isNoAd) {
                        const masthead = resp.data.ad?.masthead || {};
                        fetchWithTimeout(
                            masthead.url,
                            Object.assign({}, masthead.params || {}, {
                                topicId: (window as any)._BM.customTopic,
                            }),
                        )
                            .then((mastheadResp: any) => {
                                if (mastheadResp && mastheadResp.data) {
                                    mastheadResp.data.fetched = true;
                                    data.ad.masthead = mastheadResp.data;
                                }
                            })
                            .catch(() => {
                                data.ad.masthead = {
                                    fetched: true,
                                };
                                Logger.debug(
                                    'fetch ad masthead fail:',
                                    masthead,
                                );
                            })
                            .finally(() => {
                                dispatch(putContent(data));
                            });
                    } else {
                        dispatch(putContent(data));
                    }
                } else {
                    dispatch(closeContent());
                }
            })
            .catch((err: any) => {
                if (err?.err === ERROR_CODE.NOT_FOUND_ID) {
                    Notify.message({
                        description: 'Bài viết không tồn tại!',
                        delay: 1000,
                    });

                    dispatch(closeContent());
                    return;
                }

                if (err?.message?.includes('TIMEOUT')) {
                    Notify.message({
                        description:
                            'Không tải được bài viết. Vui lòng thử lại!',
                        delay: 1000,
                    });

                    dispatch(closeContent());
                    return;
                }

                if (currentContent) {
                    dispatch(putContent(currentContent));
                }

                Logger.error(
                    err.err,
                    'openContent',
                    '|content:',
                    content,
                    '|err ',
                    err,
                );
            });
    };
